import { gql } from '@apollo/client';

export const GET_ORDERS = gql`
  query OrderQuery {
    ordersByAuthId {
      id
      orderStatus
      orderType
      extension
      orderDate
      systemId
      deliveryDate
      oldDeliveryDate
      createdDateTime
      lastModifiedDateTime
      deliveryInformation {
        address
        consumerId
        createdAt
        deliveryDate
        externalOrderDeliveryId
        orderSystemId
        pickupMaxDate
        pickupPointId
        status
        statusHistory {
          at
          status
        }
        updatedAt
        workingHours
      }
      products {
        brand
        eye {
          property
          value
        }
        packSize
        productQuantity
        productOwner {
          type
          profile {
            firstName
            lastName
            isActive
          }
        }
      }
      store {
        name
        address
        disabled
        workingHours
        phone
        code
        storeSubType
        latitude
        longitude
        displayName
        city
      }
      salesforceStoreInfo {
        rating
      }
      voucherId
      voucher {
        type
        title
        description
        value
        rules {
          exactAmountOfProductsRule {
            amount
          }
          matchAmountWithProductRule {
            amount
          }
        }
      }
      purchases {
        purchaseDate
      }
      orderPrice {
        discount
        orderPriceWithDiscount
        orderPriceWithoutDiscount
        deliveryDiscount
      }
      potentialPoints {
        pointsType
        value
      }
    }
    consumerLensesByAuthID {
      id
      createdManual
      brandId
      brand {
        points {
          packSize
          acuvuePoints
        }
      hiddenForC2C
      }
    }
  }
`;
